import type { EMessageChannel } from 'src/services/api';
import { getSignatureStorageChannel, isSupportedSignatureChannel, type GetUserSettingsResponse } from 'src/services/api/users/settings/types';
import { SIGNATURE_DELIMITER } from 'src/pages/landlord/leads/messages/context/composer-state';

/**
 * Formats the configured signature for a channel into the single source of truth the
 * composer reducer consumes: `\n---\n<text>` when enabled with real text, or `''`.
 *
 * An enabled-but-blank signature formats to `''` (not a bare `\n---\n`) so the composer
 * never renders a dangling delimiter — the enabled flag alone is not a signature.
 *
 * Facebook Messenger has no signature storage of its own, so it resolves to the SMS
 * signature (see `getSignatureStorageChannel`).
 */
export const getFormattedSignature = (
    channel: EMessageChannel,
    userSettings: GetUserSettingsResponse['settings']
): string => {
    const signature = isSupportedSignatureChannel(channel) ?
        userSettings.signatures[getSignatureStorageChannel(channel)] :
        undefined;
    if (!signature?.is_enabled || !signature.text.trim()) {
        return '';
    }
    return `${SIGNATURE_DELIMITER}${signature.text}`;
};
